var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "mb-0" }, [
    _c("div", { staticClass: "switch switch-left-right" }, [
      _c("input", {
        staticClass: "switch-input",
        attrs: {
          id: _vm.id,
          name: _vm.name,
          type: "checkbox",
          disabled: _vm.disabled,
        },
        domProps: { checked: _vm.checked },
        on: { change: _vm.onInputChange, click: _vm.onClick },
      }),
      _vm._v(" "),
      _c("span", {
        class: ["switch-label", { disabled: _vm.disabled }],
        attrs: { "data-on": _vm.i18n.yes, "data-off": _vm.i18n.no },
      }),
      _vm._v(" "),
      _c("span", { class: ["switch-handle", { disabled: _vm.disabled }] }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: ["toggle-switch__label", { disabled: _vm.disabled }] },
      [
        _vm._t("default", function () {
          return [_vm._v(_vm._s(_vm.label))]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }